module.exports = __webpack_public_path__ + "static/propertyforsale-03504595338eef6af1646bf931d12101.png";